import { JsonApiPayload, ModelLike } from 'services/interfaces/JsonApiPayload';

export class GuestPayload extends JsonApiPayload {
  id: string
  pmsId: string
  parkId: string
  primaryPaymentMethodId: string
  stripeCustomerId: string
  firstName: string
  middleName: string
  lastName: string
  fullName: string
  title: string
  email: string
  email2: string
  phoneType: string
  phone: string
  formattedPhone: string
  phone2Type: string
  phone2: string
  formattedPhone2: string
  address: string
  address2: string
  address3: string
  address4: string
  city: string
  state: string
  postalCode: string
  country: string
  useMailingAsBilling: boolean
  billingAddress: string
  billingAddress2: string
  billingAddress3: string
  billingAddress4: string
  billingCity: string
  billingState: string
  billingPostalCode: string
  billingCountry: string
  notes: string
  idType: string
  idState: string
  idCountry: string
  idNumber: string
  nationality: string
  language: string
  birthday: string
  termsAccepted: boolean
  marketingOptIn: boolean
  privacyOptIn: boolean
  emailOptIn: boolean
  smsOptIn: boolean
  createdAt: string
  updatedAt: string
  vehicleType: string
  vehicleLengthRange: string
  vehicleSlides: string[]
  vehicleTowing: string
  vehicleElectrical: string[]
  vehicleLength?: string   // not used now
  mostRecentReservation?: {
    id: string,
    confirmationNumber: string,
    arrivalDate: string,
    departureDate: string,
    status: string,
  }
  outstandingBalance?: number
  lifetimeSpent?: number

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    return super._getSchema(this, []);
  }
}
